import type { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
  title: string
  subtitle?: string
}

export default function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="auth-container">
      <div className="auth-content">
        <div className="auth-header">
          <h1 className="brand-title">certi</h1>
          {title && (
            <h2 className="page-title">{title}</h2>
          )}
          {subtitle && (
            <p className="page-subtitle">{subtitle}</p>
          )}
        </div>
        <div className="card" style={{ padding: '32px' }}>
          {children}
        </div>
      </div>
    </div>
  )
}